<div class="_flex _flex-col _h-full _max-h-[90vh]">
    <!-- Header -->
    <div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
        <div class="_text-h4 sm:_text-h3 _heading">Request to Book Summary</div>
        <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
    </div>

    <!-- Scrollable content with enhanced scroll handling -->
    <mat-dialog-content class="_flex-1 _min-h-0 _overflow-y-scroll _scrollbar _scrollbar-thin _scrollbar-track-gray-100 _scrollbar-thumb-gray-300 _pr-4">
      <div class="_py-8">
        <ng-container *ngIf="!requestToBookSuccess && !requestToBookFail">
            <div class="_h4 _mb-4 _font-bold">Trip Details</div>
            <dl class="_grid _grid-cols-1 xs:_grid-cols-2 _gap-y-2">
                <dt>Property name:</dt>
                <dd class="_font-bold">{{ data.listingName }}</dd>
                <dt>Check-in:</dt>
                <dd class="_font-bold">{{ checkin }}</dd>
                <dt>Check-out:</dt>
                <dd class="_font-bold">{{ checkout }}</dd>
                <dt>Total stay:</dt>
                <dd class="_font-bold">{{ data.travelDates.nights }} nights</dd>
                <dt>Total guests:</dt>
                <dd class="_font-bold">{{ data.totalGuests }}</dd>
            </dl>

            <ng-container *ngIf="data.commissionRate">
                <div class="_h4 _mb-4 _mt-8 _font-bold">
                  <span *ngIf="!data.consumerView">Fees & Commissions</span>
                  <span *ngIf="data.consumerView">Fees</span>
                </div>
                <dl class="_grid _grid-cols-2 _gap-y-2">
                    <dt>Client pays:</dt>
                    <dd class="_font-bold">{{ data.price }}</dd>
                    <ng-container *ngIf="!data.consumerView">
                      <dt>Your commission:</dt>
                      <dd class="_flex _items-center _font-bold">
                          <span class="_pill-thin">{{ data.commissionRate }}%</span>
                          <span class="_px-1">/</span>
                          <div *ngIf="(data.commissionAmount$ | async) as totalCommission">
                              {{ (totalCommission.amountMicros / 1000000) | currency: totalCommission.currency : 'symbol-narrow' : '1.0-0' }}
                          </div>
                      </dd>
                    </ng-container>
                    <ng-container *ngIf="data.ZARListing">
                        <dt>You will be charged in ZAR</dt>
                        <dd class="_font-bold">{{ data.priceInListingCurrency }}</dd>
                    </ng-container>
                </dl>
            </ng-container>

            <div class="_h4 _mb-4 _mt-8 _font-bold"><i class="fa-light fa-triangle-exclamation"></i> Request to Book Process</div>
            <ng-container *ngIf="!isWhiteLabelConsumer">
                <p>This listing is being connected to <span class="_font-italic">live</span> availability.</p>
                <p>Until then, a Reservest agent will take your request and reach out to you shortly.</p>
            </ng-container>
            <ng-container *ngIf="isWhiteLabelConsumer">
                <p>Your booking request will be handled by {{ agentName }}.</p>
                <p>They will review the details and reach out to you shortly to confirm your booking.</p>
            </ng-container>

            <div class="_h4 _mb-4 _mt-8 _font-bold">Payment Process</div>
            <ol>
                <li>No payment is due until booking is confirmed</li>
                <li>Upon confirmation, you will receive a payment link</li>
            </ol>

            <!-- Installment Schedule Logic -->
            <ng-container *ngIf="data.installmentSchedule">
                <div class="_h4 _mb-4 _mt-8 _font-bold">Payment Schedule Breakdown</div>
                <!-- Installment Amount Display -->
                <div class="_mt-4 _space-y-3">
                    <div *ngFor="let installment of data.installmentSchedule.installments; let i = index"
                         class="_bg-gray-50 _rounded-lg _p-4 _flex _flex-col sm:_flex-row _justify-between _items-center _gap-2">
                        <div class="_flex-1 _w-full sm:_w-auto">
                            <div class="_text-gray-900 _font-medium">
                                {{ formatDaysPrior(installment.daysPriorTo) | titlecase }}
                            </div>
                            <div class="_text-xs _text-gray-600">Payment Installment {{ i + 1 }} / {{ data.installmentSchedule.installments.length }}</div>
                        </div>
                        <div class="_flex _flex-col sm:_flex-row _items-end sm:_items-center _gap-2 _w-full sm:_w-auto _text-right">
                            <div class="_text-gray-700 _font-medium">
                                {{ getInstallmentAmount(installment.percentage) }}
                            </div>
                            <div class="_text-sm _text-gray-500">
                                {{ installment.percentage }}%
                            </div>
                            <span *ngIf="isPaymentDueNow(installment.daysPriorTo)"
                                  class="_pill _pill-thin _bg-primary-1 _text-white _ml-2">
                                Due now
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Commission Breakdown (if applicable) -->
                <div *ngIf="data.commissionRate && !data.consumerView" class="_mt-4 _pt-4 _border-t _border-transparency-black-5">
                    <div class="_h4 _mb-4 _mt-8 _font-bold">Your Commission Breakdown</div>
                    <div class="_space-y-3">
                        <div *ngFor="let installment of data.installmentSchedule.installments; let i = index"
                             class="_bg-gray-50 _rounded-lg _p-4 _flex _flex-col sm:_flex-row _justify-between _items-center _gap-2">
                            <div class="_flex-1 _w-full sm:_w-auto">
                                <div class="_text-gray-900 _font-medium">
                                    {{ formatDaysPrior(installment.daysPriorTo) | titlecase }}
                                </div>
                                <div class="_text-xs _text-gray-600">Commission Installment {{ i + 1 }} / {{ data.installmentSchedule.installments.length }}</div>
                            </div>
                            <div class="_flex _flex-col sm:_flex-row _items-end sm:_items-center _gap-2 _w-full sm:_w-auto _text-right">
                                <div class="_text-gray-700 _font-medium">
                                    {{ getInstallmentAmount(installment.percentage * Number(data.commissionRate) / 100) }}
                                </div>
                                <div class="_text-sm _text-gray-500">
                                    {{ data.commissionRate }}% of Installment
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="requestToBookSuccess">
            <div class="_py-10">
                <div class="_h4 _pb-4"><i class="fa-regular fa-sharp fa-circle-check _text-green-600 _mr-1"></i>Thank you
                    for your request to book.
                </div>
                <div>Your request is now being processed. You can follow the booking request status in
                    <span class="_link _inline-flex _underline" (click)="viewTrips()">Client trips</span>.
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="requestToBookFail">
            <div class="_py-10">
                <div class="_h4 _pb-4"><i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>Something
                    went wrong with your request to book.
                </div>
                <div>Please try again.</div>
            </div>
        </ng-container>
      </div>
    </mat-dialog-content>

    <!-- Footer - using flex layout -->
    <div class="_mt-auto _bg-white _flex _flex-col xs:_flex-row _justify-end _gap-2 _p-4 _pb-0 _border-t _border-gray-200">
        <ng-container *ngIf="!requestToBookSuccess && !requestToBookFail">
            <app-button
                class="_w-full xs:_w-max"
                modifierClassNames="_w-full"
                type="primary"
                [onClick]="confirm.bind(this)"
                [loading]="loadingNextStep">
                Request to book
            </app-button>
        </ng-container>
        <ng-container *ngIf="requestToBookSuccess">
            <button class="_button-primary _w-full xs:_w-max" (click)="viewTrips()">View pending bookings</button>
        </ng-container>
        <button class="_button-primary _w-full xs:_w-max" (click)="decline()">
            <ng-container *ngIf="!requestToBookSuccess && !requestToBookFail">Edit booking</ng-container>
            <ng-container *ngIf="requestToBookSuccess || requestToBookFail">Back to listing</ng-container>
        </button>
    </div>
</div>